/* --------------------------------------------------------------------------------------
   xwSegmented.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/* eslint semi: ["error", "never"]*/
export class xwSegmented {
  /* @ngInject*/
  constructor(appSettings) {
    this.restrict = "A";
    this.appSettings = appSettings;
    this.scope = {
      onSelect: "&",
      scroll: "<",
      isHorizontal: "<",
    };
  }
  link(scope, elem, attrs) {
    let options = {
      isHorizontal: attrs.isHorizontal,
      width: attrs.width,
      height: attrs.height,
      scroll: scope.scroll,
      theme: attrs.theme ? attrs.theme : this.appSettings.primaryColor,
      type: attrs.type,
      customClass: attrs.customClass,
      select: (event, ui) => scope.onSelect({ item: ui.item }),
    };

    setTimeout(() => elem.first().xrxsegmentedcontrol(options));
  }
  static directiveFactory(appSettings) {
    xwSegmented.instance = new xwSegmented(appSettings);
    return xwSegmented.instance;
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwSegmented.directive.js